/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AppEventType = {
    BALANCE_USED_ADDED: 'BALANCE_USED_ADDED',
    BALANCE_USED_SUBTRACTED: 'BALANCE_USED_SUBTRACTED',
    LIMIT_ADDED: 'LIMIT_ADDED',
    LIMIT_SUBTRACTED: 'LIMIT_SUBTRACTED',
    PRODUCT_REFUNDED: 'PRODUCT_REFUNDED',
    BALANCE_TOTAL_ADDED: 'BALANCE_TOTAL_ADDED',
    BALANCE_TOTAL_SUBTRACTED: 'BALANCE_TOTAL_SUBTRACTED',
    SMS_NOTIFICATION_CREATED: 'SMS_NOTIFICATION_CREATED',
    PUSH_NOTIFICATION_CREATED: 'PUSH_NOTIFICATION_CREATED',
    WHATSAPP_NOTIFICATION_CREATED: 'WHATSAPP_NOTIFICATION_CREATED',
    FISCALIZATION_REFUND: 'FISCALIZATION_REFUND',
    FISCALIZATION_SELL: 'FISCALIZATION_SELL',
    PAYMENT_STARTED: 'PAYMENT_STARTED',
    ORDER_REFUNDED: 'ORDER_REFUNDED',
    ORDER_RECEIVED: 'ORDER_RECEIVED',
    ORDER_PAID: 'ORDER_PAID',
    ORDER_CANCELLED: 'ORDER_CANCELLED',
    ORDER_INITED: 'ORDER_INITED',
    ORDER_CREATED: 'ORDER_CREATED',
    ORDER_MODIFIED: 'ORDER_MODIFIED',
    ORDER_PACKED: 'ORDER_PACKED',
    ORDER_DECORED: 'ORDER_DECORED',
    ORDER_TAKEN: 'ORDER_TAKEN',
    ORDER_SHIPPED: 'ORDER_SHIPPED',
    ORDER_RETURNED: 'ORDER_RETURNED',
    ORDER_ARCHIVED: 'ORDER_ARCHIVED',
    ORDER_COMPLETED: 'ORDER_COMPLETED',
    ORDER_MODIFYING: 'ORDER_MODIFYING',
    ORDER_UNARCHIVED: 'ORDER_UNARCHIVED',
    ORDER_CURBSIDE_PICKUP: 'ORDER_CURBSIDE_PICKUP',
    ORDER_CURBSIDE_PICKUP_SEEN: 'ORDER_CURBSIDE_PICKUP_SEEN',
    ORDER_MICROSTORE_PICKUP: 'ORDER_MICROSTORE_PICKUP',
    PAY_INVOICE_SENT: 'PAY_INVOICE_SENT',
    COIN_EARNED: 'COIN_EARNED',
    INVOICE_DISCARDED: 'INVOICE_DISCARDED',
    INVOICE_NEW: 'INVOICE_NEW',
    INVOICE_REJECTED: 'INVOICE_REJECTED',
    INVOICE_SENT: 'INVOICE_SENT',
    INVOICE_CANCELLED: 'INVOICE_CANCELLED',
    INVOICE_ACCEPTED: 'INVOICE_ACCEPTED',
    INVOICE_PAID: 'INVOICE_PAID',
    INVOICE_PARTIAL_PAID: 'INVOICE_PARTIAL_PAID',
    INVOICE_INVENTORY: 'INVOICE_INVENTORY',
    INVOICE_RESTORATION: 'INVOICE_RESTORATION',
    INVOICE_RESTORED: 'INVOICE_RESTORED',
    PRODUCT_IN_PROGRESS: 'PRODUCT_IN_PROGRESS',
    PRODUCT_READY: 'PRODUCT_READY',
    PRODUCT_RESTORATION: 'PRODUCT_RESTORATION',
    PRODUCT_RESTORED: 'PRODUCT_RESTORED',
    CASHBOX_SHIFT_CLOSED: 'CASHBOX_SHIFT_CLOSED',
    COMPANY_INFO_SAVED: 'COMPANY_INFO_SAVED',
    PAYMENT_INVOICE_GENERATED: 'PAYMENT_INVOICE_GENERATED',
    PRODUCT_INVOICE_GENERATED: 'PRODUCT_INVOICE_GENERATED',
    SERVICE_INVOICE_GENERATED: 'SERVICE_INVOICE_GENERATED',
    PAYMENT_APPROVAL_CREATED: 'PAYMENT_APPROVAL_CREATED',
    PAYMENT_APPROVAL_MODIFIED: 'PAYMENT_APPROVAL_MODIFIED',
    PAYMENT_APPROVAL_CANCELLED: 'PAYMENT_APPROVAL_CANCELLED',
    PAYMENT_APPROVAL_SUCCEED: 'PAYMENT_APPROVAL_SUCCEED',
    ORDER_TRANSFERRED: 'ORDER_TRANSFERRED',
    PAYMENT_APPROVAL_WAIT_PAYMENT: 'PAYMENT_APPROVAL_WAIT_PAYMENT',
    ORAL_ORDER_SELL: 'ORAL_ORDER_SELL',
    ORAL_ORDER_REFUND: 'ORAL_ORDER_REFUND'
} as const;
export type AppEventType = typeof AppEventType[keyof typeof AppEventType];

